import services from '@/config/services'

export default class AskMailService {
  constructor(http, eventBus) {
    this.http = http
    this.eventBus = eventBus
    this.baseUrl = `${services.ask_api.url}/management/askmail`
  }

  async checkConnection(opts = {}) {
    const url = `${this.baseUrl}/check-connection`
    const params = {}

    if (opts.tables) {
      params.tables = 1
    }
    if (opts.table) {
      params.table = opts.table
    }

    try {
      const res = await this.http.get(url, { params })
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }
}
